import React, {Component} from 'react';
import PasswordWrapper from 'modules/blocks/inputs/PasswordWrapper';
import _ from 'lodash';
import HttpClient from 'services/HttpClient';
import {NEW_PASSWORD} from 'constants/usersConstrains';
import validate from 'validate.js';
import {inject} from 'mobx-react';
const UPDATE_PASSWORD_URL = '/api/v1/users_password';

@inject('alertStore')
export default class PasswordSettings extends Component {

    state = {
        errors: {},
        formData: {
            old_password: '',
            password: '',
            password_confirmation: ''
        }
    };

    handleChange = e => {
        let newState = _.assign({}, this.state.formData, {[e.target.name]: e.target.value});
        this.setState({formData: newState});
    };

    submit = e => {
      e.preventDefault();
      let errors = validate(this.state.formData, NEW_PASSWORD, {fullMessages: false});
      this.setState({errors: errors || {}});
      if(!errors){
        new HttpClient().put(UPDATE_PASSWORD_URL, this.state.formData).then( () => {
          this.props.alertStore.success('Password successfully update');
          this.setState({ errors: {}, formData:{
            old_password: '',
            password: '',
            password_confirmation: ''
          }})
        }).catch(() => {
          this.props.alertStore.success('“Current password is incorrect');
          this.setState({errors: {old_password: ['Current password is incorrect']}, formData:{
            old_password: '',
            password: '',
            password_confirmation: ''
          }})
        })
      }
    };

    render() {
        return (
            <form className="reset-form" onSubmit={this.submit}>
                <div className="input-wrap">
                    <PasswordWrapper value={this.state.formData.old_password}
                                     errorText={this.state.errors.old_password}
                                     name="old_password"
                                     key="password"
                                     handleChange={this.handleChange}
                                     placeholder="Current Password"
                    />
                    <PasswordWrapper value={this.state.formData.password}
                                     errorText={this.state.errors.password}
                                     name="password"
                                     key="new_password"
                                     placeholder="New Password"
                                     handleChange={this.handleChange}/>
                    <PasswordWrapper value={this.state.formData.password_confirmation}
                                     errorText={this.state.errors.password_confirmation}
                                     name="password_confirmation"
                                     key="password_confirmation"
                                     placeholder="Confirm New Password"
                                     handleChange={this.handleChange}/>
                </div>
                <div className="button-set">
                    <button className="btn-new-main" type="submit">Change
                        Password</button>
                </div>
            </form>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/profile/components/PasswordSettings.js